<button
  type="button"
  class="btn ellipsis"
  mat-button=""
  [disabled]="disabled"
  [disableRipple]="disableRipple"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  [matMenuTriggerFor]="multiSelectMenu"
>
  <ng-content></ng-content>
</button>

<mat-menu #multiSelectMenu="matMenu" class="menu-width-md">
  <ng-template matMenuContent="">
    <div *ngIf="hasSearch" class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
      <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
      <input
        type="text"
        #searchInput
        (click)="$event.stopPropagation()"
        [placeholder]="searchPlaceholder"
        [formControl]="searchControl"
      />
    </div>
    <div class="menu-scroll">
      <button *ngIf="allowNullValue" mat-menu-item="" (click)="setNullValue()" craftDisableFocus="" type="button">
        {{ nullValueLabel }}
      </button>

      <button
        *ngFor="let item of filteredItems | async | slice: 0 : 100; trackBy: identify"
        mat-menu-item=""
        [ngClass]="{ selected: selectedSet.has(item[idFieldName]) }"
        (click)="selectItem(item, $event)"
        craftDisableFocus=""
        [title]="item[labelFieldName]"
        type="button"
      >
        <span class="ellipsis">{{ item[labelFieldName] }}</span>
      </button>
    </div>
  </ng-template>
</mat-menu>
